<template>
  <div>
    <page-section bgcolor="bg-gray-50">
      <section-heading pre="About Us">Who We Are</section-heading>
      <div>
        <p>
          Mother-daughter midwifery team Carol Couchie and Rachel Dennis have a
          combined experience of more than 20 years. They are both members of
          Nipissing First Nation and they have worked on many First Nations and
          in large city centres across Canada. In July of 2013, together, with
          the assistance of second attendant Jane Collins, Carol and Rachel
          successfully opened a midwifery clinic in Powassan, Ontario.
        </p>
        <img
          src="/images/carol-nd-rach.jpg"
          class="w-full rounded-lg shadow-lg mt-8"
        />
      </div>
    </page-section>

    <page-section bgcolor="bg-white">
      <section-heading pre="Expansion">Dreams of Growth</section-heading>
      <div>
        <p>
          In November of 2016 KTM’s dream came true and they opened a second
          clinic on Nipissing First Nation. In later years they were joined by
          then, new registrant Emily Chartrand-Hudson of Manitoulin Island, who
          has been with the team for nearly 3 years now.
        </p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
        <div v-for="(item, i) in expansion_gallery" :key="i">
          <img class="rounded-lg shadow-lg overflow-hidden" :src="item" />
        </div>
      </div>
    </page-section>

    <page-section bgcolor="bg-gray-50">
      <section-heading pre="In The">Community</section-heading>
      <div>
        <p>
          KTM often hosts sewing and crafting workshops put on by our very
          talented friends from the community.
        </p>
      </div>

      <div>
        <img
          class="rounded-lg shadow-lg overflow-hidden w-full mb-5"
          src="/images/sewing_cover.jpg"
        />
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
        <div v-for="(item, i) in community_gallery" :key="i">
          <img class="rounded-lg shadow-lg overflow-hidden" :src="item" />
        </div>
      </div>
    </page-section>
  </div>
</template>
<script>
import SectionHeading from "@/components/SectionHeading";
import PageSection from "@/components/PageSection";

export default {
  components: {
    SectionHeading,
    PageSection,
  },
  data() {
    return {
      expansion_gallery: [
        "/images/expansion1.jpg",
        "/images/expansion2.jpg",
        "/images/expansion3.jpg",
      ],
      community_gallery: [
        "/images/sewing1.jpg",
        "/images/sewing2.jpg",
        "/images/sewing3.jpg",
        "/images/sewing4.jpg",
        "/images/sewing5.jpg",
        "/images/sewing6.jpg",
      ],
    };
  },
};
</script>